// Regras de leitura do extrato financeiro (vw_extrato_evento / vw_caixa_por_origem).
//
// A view manda o campo `tipo` COM acento ("saída"), então comparar com "saida"
// (sem acento) nunca casava: a despesa aparecia como entrada (verde, com "+") e o
// saldo do caixa somava a despesa em vez de subtrair.

// Normaliza texto: minúsculas e sem acento (NFD + remove marcas).
function normalizar(v: string | null | undefined): string {
  return (v ?? '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim()
    .toLowerCase();
}

// true quando a linha é uma saída (despesa, estorno da loja...).
export function ehSaida(tipo: string | null | undefined): boolean {
  return normalizar(tipo) === 'saida';
}

interface PartesData {
  ano: number;
  mes: number;
  dia: number;
  hora: number | null;
  minuto: number | null;
  segundo: number;
}

// Lê ano/mês/dia/hora direto do texto ISO, sem passar por new Date().
function partes(iso: string | null | undefined): PartesData | null {
  if (!iso) return null;
  const m = /^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2})(?::(\d{2}))?)?/.exec(iso.trim());
  if (!m) return null;
  return {
    ano: Number(m[1]),
    mes: Number(m[2]),
    dia: Number(m[3]),
    hora: m[4] === undefined ? null : Number(m[4]),
    minuto: m[5] === undefined ? null : Number(m[5]),
    segundo: m[6] === undefined ? 0 : Number(m[6]),
  };
}

// Data SEM hora (ex.: despesa "paga em 12/10/2026") chega como meia-noite UTC, e
// new Date() "volta 3 h" no fuso do Brasil (mostraria 11/10 21:00). Aqui montamos
// "dd/mm/aaaa" a partir de ano/mês/dia. Retorna null quando a linha TEM hora real.
export function dataSemHora(iso: string | null | undefined): string | null {
  const p = partes(iso);
  if (!p) return null;
  const semHora =
    (p.hora === null || p.hora === 0) &&
    (p.minuto === null || p.minuto === 0) &&
    p.segundo === 0;
  if (!semHora) return null;
  return `${String(p.dia).padStart(2, '0')}/${String(p.mes).padStart(2, '0')}/${p.ano}`;
}

// Data local correta para filtrar/agrupar: usa ano/mês/dia quando não há hora
// (assim a meia-noite UTC não cai no dia anterior).
export function paraDataLocal(iso: string | null | undefined): Date {
  const p = partes(iso);
  if (p && dataSemHora(iso)) {
    return new Date(p.ano, p.mes - 1, p.dia);
  }
  return new Date(iso ?? '');
}